import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import leftchevron from "../../Images/leftchevron.png";
import { useTranslation } from "react-i18next";
import LemaqLogonobackground from "../../Images/LemaqLogonobackground.png";

export default function CheckOutHeader() {
  const { t, i18n } = useTranslation();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();
  const handleDivClick = (CategoryName) => {
    history.push(`/${CategoryName}`); // Navigate to the root path
  };
  return (
    <div style={{}}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: 15,
          paddingBottom: 15,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: MyWidth <= 1024 ? 20 : 0,
          }}
          onClick={() => {
            handleDivClick("");
          }}
        >
          <img
            src={leftchevron}
            style={{
              width: 18,
              height: 18,
              cursor: "pointer",
              margin: 0,
              opacity: 0.5,
              //opacity: currentSlide === 0 ? 0.3 : 1,
              //cursor: currentSlide === 0 ? "" : "pointer",
            }}
          />
          {MyWidth <= 1024 ? (
            <></>
          ) : (
            <>
              <p
                style={{
                  cursor: "pointer",
                  margin: 0,
                  opacity: 0.5,
                }}
              >
                &nbsp;{t("profile.Countinueshopping")}
              </p>
            </>
          )}
        </div>
        <img
          onClick={() => {
            handleDivClick("");
          }}
          src={LemaqLogonobackground}
          alt="logo"
          style={{
            minWidth: MyWidth <= 1024 ? "40px" : "45px", // Adjust the size
            height: MyWidth <= 1024 ? "40px" : "45px", // Adjust the size
            cursor: "pointer",
          }}
        />
        {/* <p
          onClick={() => {
            handleDivClick("");
          }}
          style={{
            fontSize: MyWidth <= 1024 ? 15 : 30,
            cursor: "pointer",
            margin: 0,
            fontWeight: 500,
          }}
        >
          Make Up Logo
        </p> */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          {MyWidth <= 1024 ? (
            <></>
          ) : (
            <>
              <p style={{ margin: 0, fontSize: 18, fontWeight: "500" }}>
                +972 52-747-7128
              </p>

              <p style={{ margin: 0, fontSize: 15, opacity: 0.5 }}>
                {t("profile.SunFri")}
              </p>
            </>
          )}
        </div>
      </div>
      <div
        style={{
          width: "100%",
          backgroundColor: "#f4f4f5",
          height: "1px",
        }}
      ></div>
    </div>
  );
}
